<template>
    <svg class="svg-icon" aria-hidden="true">
        <use :xlink:href="`#icon-${name}`" />
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        name: { type: String, required: true }
    }
}
</script>

<style scoped>
.svg-icon {
    width: 16px;
    height: 16px;
    fill: currentColor;
}
</style>